import { render, staticRenderFns } from "./vouchersRecord.vue?vue&type=template&id=c83d75ce&scoped=true"
import script from "./vouchersRecord.vue?vue&type=script&lang=js"
export * from "./vouchersRecord.vue?vue&type=script&lang=js"
import style0 from "./vouchersRecord.vue?vue&type=style&index=0&id=c83d75ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83d75ce",
  null
  
)

export default component.exports